import { formatDate } from '@/utils/formUtils'
import { taskStatusList } from 'json/production-task'
import { getEnumeration } from 'enumeration'
import {
  getDeliveryType
} from 'enumeration/lab-order.js'

export default {
  formatTaskDetail(ele) {
    ele.create_time = formatDate(ele.createTime, 'date')
    ele.start_time = formatDate(ele.startTime, 'date')
    ele.end_time = formatDate(ele.endTime, 'date')
    ele.status_text = ele.status === 'NO_ORDER' ? '无样品' : getEnumeration(ele.status, taskStatusList)
    ele.delivery_type = ele.deliveryType ? ele.deliveryType.map(e => getDeliveryType(e)).toString() : ''
    ele.item_names = ele.itemNames && ele.itemNames.replace('/', '、')
    return ele
  }
}